var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldSmartCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.409 9.43a.76.76 0 0 1-.39-.99c.19-.43.08-1.06-.27-1.58-.35-.53-.88-.89-1.36-.86-.44 0-.75-.33-.76-.74 0-.42.33-.75.74-.76 1.03-.02 2 .57 2.63 1.52.64.96.79 2.11.4 3.01-.12.29-.4.46-.69.46-.1 0-.2-.02-.3-.06z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.62 10.45a.745.745 0 0 1-.52-.92c.38-1.36.06-2.98-.85-4.34-.91-1.36-2.29-2.27-3.7-2.44a.744.744 0 0 1-.65-.83c.05-.41.43-.71.83-.65 1.83.22 3.61 1.38 4.76 3.1 1.15 1.72 1.54 3.8 1.05 5.58-.09.31-.39.53-.72.53-.07 0-.13-.01-.2-.03zM16.569 12.33H3.429c-.3 0-.55-.25-.55-.55 0-.3.25-.55.55-.55h.74l.28-1.32c.26-1.28.81-2.45 2.99-2.45h5.13c2.18 0 2.72 1.18 2.99 2.45l.28 1.32h.74c.29 0 .54.25.54.55 0 .3-.25.55-.55.55z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.66 13.422H5.34c-2.34 0-2.66 1.29-2.77 2.49l-.41 4.45c-.05.55.13 1.11.51 1.53.39.42.93.66 1.52.66h1.37c1.18 0 1.41-.68 1.56-1.12l.15-.44c.17-.5.21-.63.87-.63h3.74c.66 0 .68.07.87.63l.15.44c.15.45.37 1.12 1.56 1.12h1.37c.58 0 1.13-.24 1.52-.66.38-.42.56-.97.51-1.53l-.43-4.45c-.11-1.2-.43-2.49-2.77-2.49zm-9.04 4.01c-.3 0-.55-.25-.55-.55 0-.3.25-.55.55-.55h2.19c.3 0 .55.25.55.55 0 .3-.25.55-.55.55H5.62zm6.57 0c-.3 0-.55-.25-.55-.55 0-.3.25-.55.55-.55h2.19c.3 0 .55.25.55.55 0 .3-.25.55-.55.55h-2.19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSmartCar);
export default __webpack_public_path__ + "static/media/vuesax-bold-smart-car.c6bcae7eb3b90e13a2655794affcac69.svg";
export { ForwardRef as ReactComponent };